import { render, staticRenderFns } from "./MyProfileDialog.vue?vue&type=template&id=19e7e250&"
import script from "./MyProfileDialog.vue?vue&type=script&lang=js&"
export * from "./MyProfileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports